import { BbTableService, TableRow } from './../../../services/bb-table.service';
import { TranslateService } from '@ngx-translate/core';
import { OverlayService } from './../../../services/overlay.service';
import { SapiService } from './../../../services/sapi.service';
import { Component, EventEmitter, Output, Input, OnInit, OnDestroy } from '@angular/core';


@Component({
	selector: 'bb-mediaclips-publisher',
	templateUrl: './bb-mediaclips-publisher.component.html',
	styleUrls: ['./bb-mediaclips-publisher.component.scss']
})

export class BbMediaclipsPublisherComponent implements OnInit, OnDestroy {
	@Input() toPublishMediaClips: any[];

	@Output() allClipsPublished: EventEmitter<null>;
	@Output() continue: EventEmitter<null>;
	@Output() cancel: EventEmitter<null>;
	@Output() error: EventEmitter<null>;

	rows: TableRow[];

	constructor(
		private _sapiService: SapiService,
		private _overlayService: OverlayService,
		private _translate: TranslateService,
		private _bbTableService: BbTableService
	) {
		this.allClipsPublished = new EventEmitter<null>();
		this.cancel = new EventEmitter<null>();
		this.error = new EventEmitter<null>();
		this.continue = new EventEmitter<null>();

		this._bbTableService.rowsRetrievedObservable.subscribe(rows => {
			this.rows = rows;
		});

	}

	ngOnInit() {
		this._bbTableService
			.setLimit(10)
			.sort('createddate', 'desc').setData(this.toPublishMediaClips).getRows();
	}

	ngOnDestroy() {
	}

	public publishAsIs(): void {
		this.continue.emit();
	}

	public publishAllDraftClips(): void {
		const clipIds: number[] = new Array<number>();
		for (let i = 0, l: number = this.toPublishMediaClips.length; i < l; i++) {
			clipIds.push(this.toPublishMediaClips[i].id);
		}
		this._sapiService.updateMultiple('mediaclip', clipIds, 'status', 'published').subscribe(
			(data) => {
				const msg = this._translate.instant('MEDIACLIPS_ACTION_WITH_PAYLOAD_SUCCESSFUL', { items: clipIds });
				this._overlayService.createToast(msg, 'info-circle');
			},
			(err) => {
				this._overlayService.createToast(this._translate.instant('ERROR', { items: clipIds }), 'check');
				this.error.emit();
			}
		);

		this.allClipsPublished.emit();
	}

	public cancelPublish(): void {
		this.cancel.emit();
	}
}
